<script lang="ts">
    import DOMPurify from 'isomorphic-dompurify';

    interface SafeHtmlProperties {
        html: string;
        class?: string;
    }

    let { html, class: className = '' }: SafeHtmlProperties = $props();

    const sanitizedHtml = $derived(DOMPurify.sanitize(html));
</script>

<!-- eslint-disable-next-line svelte/no-at-html-tags -->
<div class={className}>{@html sanitizedHtml}</div>
